import React, { useEffect, useMemo, useState } from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {resendEmail} from "../../store/main/action";
import {getUserData} from "../../store/cabinet/action";

const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const sec = seconds % 60;

    return `${String(minutes).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
};

const getSecondsLeft = (availableAt) => {
    if (!availableAt) return 0;

    return Math.max(Math.ceil((availableAt - Date.now()) / 1000), 0);
};

const getStoredAvailableAt = (storageKey) => {
    try {
        const value = localStorage.getItem(storageKey);

        return value ? Number(value) : null;
    } catch (err) {
        return null;
    }
};

const setStoredAvailableAt = (storageKey, value) => {
    try {
        localStorage.setItem(storageKey, String(value));
    } catch (err) {
        // localStorage может быть недоступен, например в private mode
    }
};

const VerifyEmailMain = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const userData = useSelector(store => store.cabinet.userData);
    const resendEmailStatusStarted = useSelector(store => store.main.resendEmailStatusStarted);

    const resendTimeSec = useMemo(() => {
        const envTime = Number(process.env.REACT_APP_EMAIL_RESEND_TIME_SEC);

        return Number.isFinite(envTime) && envTime > 0 ? envTime : 120;
    }, []);

    const storageKey = useMemo(() => {
        if (!userData?.email) return null;

        return `verify_email_resend_available_at_${userData.email}`;
    }, [userData?.email]);

    const [resendAvailableAt, setResendAvailableAt] = useState(null);
    const [resendTimer, setResendTimer] = useState(resendTimeSec);
    const [isTimerInitialized, setIsTimerInitialized] = useState(false);

    const isResendDisabled = !isTimerInitialized || resendTimer > 0;

    useEffect(() => {
        if (!storageKey) return;

        const storedAvailableAt = getStoredAvailableAt(storageKey);

        if (storedAvailableAt) {
            setResendAvailableAt(storedAvailableAt);
            setResendTimer(getSecondsLeft(storedAvailableAt));
            setIsTimerInitialized(true);

            return;
        }

        const initialAvailableAt = Date.now() + resendTimeSec * 1000;

        setStoredAvailableAt(storageKey, initialAvailableAt);
        setResendAvailableAt(initialAvailableAt);
        setResendTimer(getSecondsLeft(initialAvailableAt));
        setIsTimerInitialized(true);
    }, [storageKey, resendTimeSec]);

    useEffect(() => {
        if (!resendAvailableAt) return;

        const interval = setInterval(() => {
            setResendTimer(getSecondsLeft(resendAvailableAt));
        }, 1000);

        return () => clearInterval(interval);
    }, [resendAvailableAt]);

    const handleConfirmEmail = () => {
        dispatch(getUserData())
    };

    const handleResendLink = () => {
        if (isResendDisabled || !storageKey || resendEmailStatusStarted) return;

        dispatch(resendEmail());

        const nextAvailableAt = Date.now() + resendTimeSec * 1000;

        setStoredAvailableAt(storageKey, nextAvailableAt);
        setResendAvailableAt(nextAvailableAt);
        setResendTimer(getSecondsLeft(nextAvailableAt));
    };

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={Styles.formWrap}>
                    <div className={Styles.formTitle}>
                        {t('Подтвердите, что это вы')}
                    </div>

                    <div className={Styles.formSubTitle}>
                        {t('Мы отправили ссылку для подтверждения на вашу почту. Откройте её и подтвердите email-адрес, чтобы продолжить.')}
                    </div>

                    <div className={Styles.contentBox}>
                        <div className={Styles.emailRow}>
                            {t('Ссылка для подтверждения отправлена на')} <span>{userData?.email}</span>
                        </div>

                        <div className={Styles.btnWrap}>
                            <button
                                type="button"
                                className={Styles.confirmBtn}
                                onClick={handleConfirmEmail}
                            >
                                {t('Я подтвердил email')}
                            </button>

                            <button
                                type="button"
                                className={`${Styles.resendBtn} ${isResendDisabled ? Styles.disabled : ''}`}
                                onClick={handleResendLink}
                                disabled={isResendDisabled}
                            >
                                {isResendDisabled
                                    ? `${t('Отправить повторно через')} ${formatTime(resendTimer)}`
                                    : t('Отправить ссылку повторно')}
                            </button>
                        </div>

                        <div className={Styles.verifyErrRow}>
                            <div className={Styles.verifyErrMsg}>
                                <div className={Styles.verifyErrText}>
                                    {t('Мы ещё не получили подтверждение вашего email. Подтвердите почту по отправленной ссылке, затем попробуйте снова.')}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={Styles.imgWrap} />
            </div>
        </section>
    );
};

export default VerifyEmailMain;